module.exports = __webpack_public_path__ + "static/media/filled_bar_packShip.d9350c29.svg";